import request from '@/utils/request'

// 查询合同信息列表
export function contractsInfoList(query) {
  return request({
    url: '/contractsInfo/list',
    method: 'get',
    params: query
  })
}
// 查询合同信息列表统计数据
export function contractsStatistics(query) {
  return request({
    url: '/contractsInfo/statistics/archive/list',
    method: 'get',
    params: query
  })
}
// 新增合同
export function addContract(data) {
  return request({
    url: '/contractsInfo',
    method: 'post',
    data: data
  })
}

// 合同详情
export function contractsInfo(id) {
  return request({
    url: '/contractsInfo/' + id,
    method: 'get'
  })
}
// 合同详情佣金
export function commissionRecord(query) {
  return request({
    url: '/system/commissionRecord/list',
    method: 'get',
    params: query
  })
}
// 新增佣金记录
export function addCommission(data) {
  return request({
    url: '/system/commissionRecord',
    method: 'post',
    data: data
  })
}
// 修改佣金记录
export function editCommission(data) {
  return request({
    url: '/system/commissionRecord',
    method: 'put',
    data: data
  })
}
// 冲红
export function rushCommission(data) {
  return request({
    url: '/system/commissionRecord/rush/performance',
    method: 'post',
    data: data
  })
}
// 查询业绩分配记录列表
export function achievementsAllotRecord(query) {
  return request({
    url: '/system/achievementsAllotRecord/list',
    method: 'get',
    params: query
  })
}
// 批量删除佣金记录
export function deleteCommission(ids) {
  return request({
    url: '/system/commissionRecord/' + ids,
    method: 'delete'
  })
}
// 编辑合同
export function editContractsInfo(data) {
  return request({
    url: '/contractsInfo',
    method: 'put',
    data: data
  })
}
// 合同归档
export function contractFile(id) {
  return request({
    url: '/contractsInfo/archive/' + id,
    method: 'put'
    // data: data
  })
}
// 删除业绩分配设置
export function deleteAchievement(id) {
  return request({
    url: '/system/achievementsAllotRecord/' + id,
    method: 'delete'
    // data: data
  })
}
// 新增业绩分配记录
export function addAchievementsAllotRecord(data) {
  return request({
    url: '/system/achievementsAllotRecord',
    method: 'post',
    data: data
  })
}
// 修改业绩分配记录
export function editAchievementsAllotRecord(data) {
  return request({
    url: '/system/achievementsAllotRecord',
    method: 'put',
    data: data
  })
}
// 删除合同信息
export function deleteContractsInfo(ids) {
  return request({
    url: '/contractsInfo/' + ids,
    method: 'delete'
  })
}
//
export function contractExamine(id) {
  return request({
    url: '/contractsInfo/approval/' + id,
    method: 'post'
    // data: data
  })
}

// 更新合同附件
export function updateAccessory(data) {
  return request({
    url: '/contractsInfo/update/accessory',
    method: 'put',
    data: data
  })
}
// 查询佣金记录明细列表
export function commissionRecordDetail(query) {
  return request({
    url: '/contracts/commissionRecordDetail/list',
    method: 'get',
    params: query
  })
}
// 新增合同
export function addCommissionRecordDetail(data) {
  return request({
    url: '/contracts/commissionRecordDetail',
    method: 'post',
    data: data
  })
}
// 确认分配业绩
export function getAchievements(data) {
  return request({
    url: '/system/achievementsAllotRecord/confirm/Allot/Achievements',
    method: 'put',
    data: data
  })
}

// 修改合同租客信息
export function edit_contractLessee(data) {
  return request({
    url: '/contractsInfo/update/contract/lessee',
    method: 'put',
    data: data
  })
}

// 修改合同的业主-二房东信息
export function edit_contractLessor(data) {
  return request({
    url: '/contractsInfo/update/contract/lessor',
    method: 'put',
    data: data
  })
}

// 修改合同的交件和结佣状态
export function edit_contractDelivery(data) {
  return request({
    url: '/contractsInfo/update/delivery',
    method: 'put',
    data: data
  })
}

